<template>
  <v-card
      class="mt-3"
      :disabled="getTag.uuid == -1"
  >
    <v-card-title
    >
      Tag bearbeiten
      <div
          :style="'position: relative; top: -10px; left: 3px; color: ' + getTag.color"
      >
        <h6>
          {{getTag.name}}
        </h6>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        @click="deleteTag"
      >
        Löschen
      </v-btn>
    </v-card-title>
    <v-card-subtitle
      align="left"
    >
      uuid: {{getTag.uuid}}
    </v-card-subtitle>
    <v-card-text>
      <v-text-field
          v-model="getTag.name"
          label="Name"
          @input="update"
      >
      </v-text-field>
      <v-color-picker
          v-model="getTag.color"
          width="100%"
          hide-canvas
          hide-inputs
          @input="update"
      ></v-color-picker>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TagEditorBox",
  props: ["currentTagUUID"],
  methods: {
    update(){
      if(this.getTag != null && this.getTag.uuid != -1){
        let tag = this.getTag
        this.$store.dispatch('update', {"context": '/set/kanban/tags/' + tag.uuid, "payload": tag})
      }
    },
    deleteTag(){
      let tags = this.$store.getters.getKanban.tags
      const index = tags.indexOf(this.getTag);
      if (index > -1) { // only splice array when item is found
        tags.splice(index, 1); // 2nd parameter means remove one item only
      }
      this.$store.commit('updateTags', tags)
      this.$store.dispatch('update', {"context": '/delete/kanban/tags/' + this.currentTagUUID})
    },
  },
  computed: {
    getTag(){
      if(this.currentTagUUID != null){
        for (let index in this.$store.getters.getKanban.tags){
          let tag = this.$store.getters.getKanban.tags[index]
          if(tag.uuid == this.currentTagUUID){
            return tag
          }
        }
      }
      //Placeholder Tag
      return {uuid: "-1", name: "Beispiel", color: this.$vuetify.theme.currentTheme.primary}
    }
  }
}
</script>

<style scoped>

</style>